import React, { ReactNode, useEffect, useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import { ReactComponent as ArrowDownIcon } from "../../assets/icons/arrow_down.svg";
import { ReactComponent as EditIcon } from "../../assets/icons/edit.svg";
import MobileSearch from "../Search/MobileSearch";
import Search from "../Search/Search";
import { useKioskMode } from "../../context/KioskModeContext";

type Props = {
  title: string;
  goBackTo?: string;
  searchFunction?: any;
  mainAction?: ReactNode;
  editable?: boolean;
  onTitleChange?: (newTitle: string) => void;
  // authSocket: any,
};

const Header = (props: Props) => {
  const { isKioskMode } = useKioskMode();
  const [windowSize, setWindowSize] = useState(getWindowSize());
  const [searchState, setSearchState] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(props.title || "");
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }
    window.addEventListener("resize", handleWindowResize);
  }, []);

  useEffect(() => {
    setEditValue(props.title || "");
  }, [props.title]);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [isEditing]);

  // Hide header in kiosk mode
  if (isKioskMode) {
    return null;
  }

  const handleEditClick = () => {
    if (props.editable) {
      setIsEditing(true);
    }
  };

  const handleSave = () => {
    if (editValue.trim() && editValue !== props.title) {
      props.onTitleChange?.(editValue.trim());
    } else {
      setEditValue(props.title || "");
    }
    setIsEditing(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleSave();
    } else if (e.key === "Escape") {
      setEditValue(props.title || "");
      setIsEditing(false);
    }
  };

  const renderTitle = () => {
    if (isEditing) {
      return (
        <input
          ref={inputRef}
          type="text"
          className="title-input"
          value={editValue}
          onChange={(e) => setEditValue(e.target.value)}
          onBlur={handleSave}
          onKeyDown={handleKeyDown}
        />
      );
    }

    return (
      <div className={`title-container ${props.editable ? "editable" : ""}`} onClick={handleEditClick}>
        <h3 className="title">{props.title}</h3>
        {props.editable && <EditIcon className="edit-icon" />}
      </div>
    );
  };

  // TODO: Replace with ismobile
  return windowSize.innerWidth > 600 ? (
    <div className="header">
      {props.goBackTo && (
        <NavLink to={props.goBackTo} className="device-actions">
          <ArrowDownIcon />
        </NavLink>
      )}
      {/* Title first so it stays left-aligned whether or not a page opts
          into the header search. */}
      <div className="header-title">{renderTitle()}</div>
      {props.searchFunction && (
        <div className="search">
          <Search onChange={props.searchFunction} />
        </div>
      )}
      <div className="main-action">{props.mainAction && props.mainAction}</div>
    </div>
  ) : (
    <div className="header">
      {props.goBackTo && (
        <NavLink to={props.goBackTo} className="device-actions">
          <ArrowDownIcon />
        </NavLink>
      )}
      {props.searchFunction && (
        <>
          <MobileSearch
            onChange={props.searchFunction}
            state={setSearchState}
          />
        </>
      )}
      {!searchState ? (
        <>
          <div>
            {renderTitle()}
          </div>
          <div className="main-action">
            {props.mainAction && props.mainAction}
          </div>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default Header;

function getWindowSize() {
  const { innerWidth, innerHeight } = window;
  return { innerWidth, innerHeight };
}
